import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useDraftsMetadata } from 'apps/web_forms/hooks/useDraftsMetadata';
import { setSelectedForm } from 'apps/web_forms/slices/appSlice';
import { APP_ROUTES, ORIGINS, FormTypes } from 'apps/web_forms/utils/constants';

import DraftList from './DraftList';
import { ModalWrapper } from 'apps/web_forms/components/Modals';

const DraftsPage = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const { drafts, loading } = useDraftsMetadata();
  const nonDispatchDrafts = drafts.filter(
    (draft) => draft.type === FormTypes.DRAFT
  );
  const dispatchDrafts = drafts.filter(
    (draft) => draft.type === FormTypes.DISPATCH_DRAFT
  );

  const goToForm = (formId, draftId) => {
    const draft = drafts.find((theDraft) => theDraft.identifier == draftId);
    dispatch(setSelectedForm(draft));
    history.push(
      APP_ROUTES.getFormPageById(
        formId,
        `?origin=${ORIGINS.Draft}&id=${draftId}`
      )
    );
  };

  const draftsListCommonProps = {
    loading,
    goToForm,
  };

  const nonDispatchDraftsProps = {
    ...draftsListCommonProps,
    draftsToList: nonDispatchDrafts,
    title: 'Drafts',
    description: 'Unsubmitted drafts',
  };

  const dispatchDraftsProps = {
    ...draftsListCommonProps,
    draftsToList: dispatchDrafts,
    title: 'Dispatch Drafts',
    description: 'Unsubmitted dispatch drafts',
  };

  return (
    <>
      <ModalWrapper />
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <DraftList {...nonDispatchDraftsProps} />
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <DraftList {...dispatchDraftsProps} />
    </>
  );
};

export default DraftsPage;
